import { Provider } from "@angular/core";
import { MobileAuthHttpService } from "./mobile-auth-http.service";
import { MOBILE_AUTH_SERVICE } from "./mobile-auth.service.interface";

export function provideMobileAuthService(): Provider[] {
  return [
    MobileAuthHttpService,
    {
      provide: MOBILE_AUTH_SERVICE,
      useExisting: MobileAuthHttpService,
    },
  ];
}
